//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import intro from './intro'
import contact from './contact'
import intelligence from './intelligence'
import join from './join'
export default {
  data () {
    return {
      activePage: '1'
    }
  },
  components: {
    intro,
    contact,
    intelligence,
    join
  },
  methods: {
    selectedIntro (val) {
      this.activePage = val
    }
  },
  created () {
    // console.log('this.$route.params', this.$route.params)
    this.activePage = this.$route.params.active || '1'
  }
}



// WEBPACK FOOTER //
// ./src/views/aboutOur/index.vue